import {
  SingleItemDropdownInterface,
  SingleItemHrefInterface,
} from 'shared/components/header/types/menu-interface'

export const isFlatMenuItem = (
  item: SingleItemDropdownInterface | SingleItemHrefInterface,
): item is SingleItemHrefInterface => 'href' in item
